module.exports = __webpack_public_path__ + "img/mastercard2.4ee37574.png";